(function () {
  var nav = document.querySelector('.bt-bnav');
  if (!nav) return;
  var toggle = nav.querySelector('[data-bt-shop-toggle]');
  var sheet = document.querySelector('[data-bt-shop-sheet]');
  var backdrop = document.querySelector('[data-bt-sheet-backdrop]');
  function setOpen(open) {
    if (!sheet || !toggle) return;
    sheet.hidden = !open;
    if (backdrop) backdrop.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var first = sheet.querySelector('a');
      if (first) first.focus();
    } else {
      toggle.focus();
    }
  }
  if (toggle && sheet) {
    toggle.addEventListener('click', function () { setOpen(sheet.hidden); });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 750 && !sheet.hidden) { sheet.hidden = true; if (backdrop) backdrop.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    });
  }
  var cartTab = nav.querySelector('[data-bt-bnav-cart]');
  if (cartTab) {
    cartTab.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        if (sheet && !sheet.hidden) setOpen(false);
        drawer.open(cartTab);
      }
    });
  }
  var badge = nav.querySelector('[data-bt-bnav-count]');
  function setCount(n) {
    if (!badge || !cartTab) return;
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n === 0;
    cartTab.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
  }
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count || 0); })
      .catch(function () {});
  }
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
